const filterReducer = (state, action) => {
	switch (action.type) {
		case "FILTER_ARTICLES":
			const regex = new RegExp(`${action.payload.text}`, "ig")
			let filteredArticles = []
			switch (action.payload.attributeName) {
				case "category":
					filteredArticles = state.articles.filter((article) => {
						return article.data.categories.some((currentValue) =>
							currentValue?.category?.slug?.match(regex)
						)
					})

					return {
						...state,
						isFiltered: true,
						filtered: filteredArticles,
					}
				default:
					if (state.filtered.length) {
						filteredArticles = state.filtered.filter((article) => {
							return article.data[action.payload.attributeName][0]?.text.match(regex)
						})
					} else {
						filteredArticles = state.articles.filter((article) => {
							return article.data[action.payload.attributeName][0]?.text.match(regex)
						})
					}
					return {
						...state,
						isSearched: true,
						searchResults: filteredArticles,
					}
			}

		case "CLEAR_FILTER":
			return {
				...state,
				isFiltered: false,
				filtered: [],
			}

		case "CLEAR_SEARCH":
			return {
				...state,
				isSearched: false,
				searchResults: [],
			}

		case "UPDATE":
			return { ...state, articles: [...action.payload] }

		case "SET_STICKY_HEADER":
			return {
				...state,
				isStickyHeader: action.payload,
			}

		case "SET_PAGINATION":
			return {
				...state,
				paginationVal: action.payload,
			}

		case "SET_FILTER_CATEGORY":
			return {
				...state,
				filterCat: action.payload,
			}

		case "SET_SEARCH_QUERY":
			return {
				...state,
				searchQuery: action.payload,
			}

		case "SET_ARTICLES_TO_SHOW":
			return {
				...state,
				articlesToShow: action.payload,
			}

		default:
			return state
	}
}

export default filterReducer
